
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import Cookies from 'js-cookie';
import en_us from '@/lang/en_us.json';
import zh_cn from '@/lang/zh_cn.json';
Vue.use(VueI18n);

let langJson = {
	'en_us': en_us,
	'zh_cn': zh_cn
}

let lang = '';
// #ifdef MP || APP-PLUS
lang = Cookies.get('ck-language') != undefined? Cookies.get('ck-language'): 'en_us';
// #endif
// #ifdef H5
lang = Cookies.get('ck-language') != undefined? Cookies.get('ck-language'): navigator.language.toLowerCase().replace('-','_');
// #endif

const i18n = new VueI18n({
	locale: lang in langJson ? lang :'en_us',
	messages: langJson
})

export default i18n